import React from 'react';
import MaterialDivider from '@mui/material/Divider';
import type {DividerProps as MaterialDividerProps} from '@mui/material/Divider';

export type DividerProps = MaterialDividerProps;

export const Divider = React.forwardRef<HTMLHRElement, DividerProps>(
    (
        {...props},
        ref
    ) => {
        return (
            <MaterialDivider
                ref={ref}
                {...props}
            />
        );
    });

Divider.displayName = 'Divider';
